<template>
  <!-- 个人中心 -->
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>
    <div v-show="userProfile.name" class="mar-all pad-all bg-white">
      <div>
        <span class="text-lg text-bold">{{userProfile.name}}</span>
      </div>
      <div class="mar-top-5">
        <span>{{userProfile.position}}</span>
        <span class="pull-right">{{userProfile.employeeNumber}}</span>
      </div>
      <van-divider></van-divider>
      <p v-for="(dept,idx) in userProfile.deptNames" :key="idx" class="mar-btm-0">{{dept}}</p>
    </div>
    <!-- 服务人员特有 -->
    <!--<div v-show="serviceRooms.length">
      <van-cell-group class="mar-top">
        <van-cell is-link :to="cellRouteTo.serviceInCharge">
          <template #title>
            <i class="fa fa-tasks mar-rgt-5"></i><span>我负责的服务</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>-->
    <div>
      <van-cell-group class="mar-top">
        <van-cell is-link :to="cellRouteTo.personalGroup">
          <template #title>
            <i class="iconfont icon-qunzu mar-rgt-5"></i><span>会议群组</span>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="mar-top">
        <van-cell is-link :to="cellRouteTo.selfFrequentContacts">
          <template #title>
            <i class="iconfont icon-yonghu mar-rgt-5"></i><span>常用联系人</span>
          </template>
        </van-cell>
        <van-cell is-link :to="cellRouteTo.selfFrequentRoom">
          <template #title>
            <i class="iconfont icon-meetingroom mar-rgt-5"></i><span>常用{{roomTitle}}</span>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="mar-top" v-show="showPermits.serviceCall || showPermits.deviceRepair">
        <van-cell v-show="showPermits.serviceCall" is-link :to="cellRouteTo.selfService">
          <template #title>
            <i class="iconfont icon-a-fuwujiaohuo mar-rgt-5"></i><span>我的服务需求</span>
          </template>
        </van-cell>
        <van-cell v-show="showPermits.deviceRepair" is-link :to="cellRouteTo.selfRepair">
          <template #title>
            <i class="iconfont icon-baoxiu mar-rgt-5"></i><span>我提交的报修</span>
          </template>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="mar-top" v-show="customerService">
        <van-cell icon="service" title="客服电话" :value="customerService"></van-cell>
      </van-cell-group>

      <van-cell-group class="mar-top">
        <van-cell is-link :to="cellRouteTo.selfSetting">
          <template #title>
            <i class="iconfont icon-shezhi mar-rgt-5"></i><span>设置</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="personal-center">
      <van-button round icon="wap-home" to="index"></van-button>
    </div>

  </div>
</template>

<script>
  import routerMeta from "../../router/routerMeta";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {checkShowPermit} from "../../../../tools/utils";

  export default {
    data() {
      return {
        // 处理跳转路由
        cellRouteTo: {
          serviceInCharge: routerMeta.serviceInCharge.path,
          selfService: routerMeta.selfService.path,
          selfRepair: routerMeta.selfRepair.path,
          selfFrequentRoom: routerMeta.selfFrequentRoom.path,
          selfFrequentContacts: routerMeta.selfFrequentContacts.path,
          selfSetting: routerMeta.selfSetting.path,
          personalGroup: routerMeta.personalGroup.path,
        },
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      // 个人相关信息
      userProfile() {
        return getStorage(StorageKey.userProfile, true) || {}
      },
      // 服务的会议室
      serviceRooms() {
        const {serviceRooms} = this.$store.state.sysConfig;
        return serviceRooms || []
      },
      // 权限
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          serviceCall: checkShowPermit(permissionList, this.permitsMap.serviceCall),
          deviceRepair: checkShowPermit(permissionList, this.permitsMap.deviceRepair),
        }
      },
      //客服联系方式
      customerService() {
        return this.$store.state.sysConfig.customerService || ''
      }
    },
    methods: {},
  }
</script>

<style lang="less" scoped>

</style>
